import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { gql } from '@apollo/client';
import FulfillmentLine from "./FulfillmentLine";
import { DateTime } from "luxon";
gql `
fragment FulfillmentItem on Fulfillment {
  ...FulfillmentLine
  id
  platformId
  platform
  deliveryMethod
  productSelections {
    product {
      id
    }
    variant {
      id
    }
  }
  membership {
    id
    activated
    ended
    user {
      id
      firstName
      lastName
      emailAddress
      phoneNumber
    }
    tier {
      id
      name
    }
    pauseStartDate
    pauseEndDate
    isPastDue
  }
  benefit {
    __typename
    id
    variants {
      platformId
      platformName
    }
    products {
      id
      platformId
      platformName
      variants {
        id
        platformId
        platformName
      }
    }
  }
  tags
}
`;
const FulfillmentItem = ({ data }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const validFulfillments = data.fulfillments.filter(f => f.benefit.__typename != "SubscriptionBenefit" || !f.benefit.isAddonOnly || f.addons.length);
    const membership = data.fulfillments[0].membership;
    const pauseStartDate = membership === null || membership === void 0 ? void 0 : membership.pauseStartDate;
    const pauseEndDate = membership === null || membership === void 0 ? void 0 : membership.pauseEndDate;
    const zone = process.env.REACT_APP_WF_TZ;
    const now = DateTime.now().setZone(zone);
    const isPaused = pauseStartDate && pauseEndDate &&
        DateTime.fromSQL(pauseStartDate, { zone }) <= now &&
        DateTime.fromSQL(pauseEndDate, { zone }) >= now;
    const pauseEndDateStr = pauseEndDate ? DateTime.fromSQL(pauseEndDate, { zone }).toLocaleString(DateTime.DATE_FULL) : '';
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    const isAddressMissing = (f) => {
        if (f.deliveryMethod === 'PICKUP') {
            return false;
        }
        const a = f.address;
        return !(!!a && !!a.line1 && !!a.city && !!a.state && !!a.zip && !!a.country);
    };
    const isProductSelectionMissing = (f) => {
        var _a, _b;
        const products = (((_a = f.benefit) === null || _a === void 0 ? void 0 : _a.products) || []).filter(Boolean);
        const selections = (f.productSelections || []).filter(Boolean);
        for (const product of products) {
            const selection = selections.find(ps => { var _a; return ((_a = ps === null || ps === void 0 ? void 0 : ps.product) === null || _a === void 0 ? void 0 : _a.id) === product.id; });
            if (!selection || !((_b = selection.variant) === null || _b === void 0 ? void 0 : _b.id)) {
                return true;
            }
            const variantIds = (product.variants || []).map((v) => v.id);
            if (!variantIds.includes(selection.variant.id)) {
                return true;
            }
        }
        return false;
    };
    const isMissingInformation = validFulfillments.some(f => isAddressMissing(f) || isProductSelectionMissing(f));
    return (validFulfillments.length
        ?
            _jsxs("div", { className: "mb-4 pb-4 border-b border-wfGray-300", children: [_jsxs("div", { className: "mb-2", children: [_jsxs("strong", { children: [(_a = membership === null || membership === void 0 ? void 0 : membership.user) === null || _a === void 0 ? void 0 : _a.firstName, " ", (_b = membership === null || membership === void 0 ? void 0 : membership.user) === null || _b === void 0 ? void 0 : _b.lastName, ": ", (_c = membership === null || membership === void 0 ? void 0 : membership.tier) === null || _c === void 0 ? void 0 : _c.name] }), _jsxs("div", { className: "prose max-w-none", children: ["Member Since: ", DateTime.fromSQL(membership === null || membership === void 0 ? void 0 : membership.activated).toLocaleString(DateTime.DATE_FULL)] }), (membership === null || membership === void 0 ? void 0 : membership.ended) && (_jsxs("div", { className: "prose max-w-none", children: ["Member Until: ", DateTime.fromSQL(membership === null || membership === void 0 ? void 0 : membership.ended).toLocaleString(DateTime.DATE_FULL)] })), ((_d = membership === null || membership === void 0 ? void 0 : membership.user) === null || _d === void 0 ? void 0 : _d.phoneNumber) && (_jsxs("div", { className: "prose max-w-none", children: ["Phone: ", (_e = membership === null || membership === void 0 ? void 0 : membership.user) === null || _e === void 0 ? void 0 : _e.phoneNumber] })), isPaused && (_jsxs("div", { className: "prose max-w-none", children: ["Paused Until: ", pauseEndDateStr] })), ((_f = membership === null || membership === void 0 ? void 0 : membership.user) === null || _f === void 0 ? void 0 : _f.emailAddress) && (_jsxs("div", { className: "prose max-w-none", children: ["Email: ", (_g = membership === null || membership === void 0 ? void 0 : membership.user) === null || _g === void 0 ? void 0 : _g.emailAddress] })), (!(membership === null || membership === void 0 ? void 0 : membership.ended) || new Date(membership.ended) > currentDate) && (membership === null || membership === void 0 ? void 0 : membership.isPastDue) && (_jsxs("div", { className: "prose max-w-none text-red-500", children: ["Past Due. ", _jsx("a", { href: "https://help.withfriends.co/6834033-understanding-our-failed-payment-recovery-process", target: "_blank", rel: "noopener noreferrer", children: "Learn more" })] })), isMissingInformation && (_jsx("div", { className: "prose max-w-none text-red-500", children: "Missing information" }))] }), validFulfillments
                        .map(f => _jsx(FulfillmentLine, { data: { "fulfillment": f } }, f.id))] })
        :
            null);
};
export default FulfillmentItem;
